import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';
import { t } from '../../../../../../i18n';
import jobActions from '../../../actions';

const ratingsApi = new Api('shifts/ratings_form_data');
const updateRatingsApi = new Api('shifts/:id/update_ratings');

function* loadFormData({ payload }) {
  const shiftToEdit = payload;

  try {
    const result = yield call(sendRequest, ratingsApi.load, {}, notifications.REQUEST_ERROR);

    if (result.data.success) {
      const {
        data: { scores },
      } = result.data.success;

      yield put(actions.loadFormDataSuccess({ scores, shiftToEdit }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateShift({ payload }) {
  try {
    const { shift, id, jobId, pages } = payload;

    const result = yield call(
      sendRequest,
      updateRatingsApi.updateItem,
      { data: { shift }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.edited_successfully', {
            item: t('dash.jobs.bookings.ratings_label'),
          }),
        }),
      );

      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
    }
  } catch (error) {
    yield put(
      notifications.addNotification({
        headline: t('dash.common.notification.error_headline'),
        type: 'error',
        message: error,
      }),
    );
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SAVE, updateShift), takeEvery(actions.LOAD, loadFormData)]);
}
